module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/23ba9e2bbe53a876ed22059ba270c319.png";